import { Typography } from "@mui/material";
import { FC } from "react";
import { LandingPageWrapper } from "./LandingPage.style";

type ILandingPageProps = {};

export const LandingPage: FC<ILandingPageProps> = () => {
  return (
    <LandingPageWrapper className="landing-page-container">
      <div className="landing-page">
        <Typography
          variant="h4"
          className="heading"
          sx={{
            fontSize: {
              xs: "1.3rem",
              sm: "2rem",
              md: "2.5rem",
              lg: "3rem",
              xl: "3.5rem",
            },
            textAlign: "center",
          }}
        >
          Quantlab function library
        </Typography>
        <Typography
          variant="body1"
          className="text"
          sx={{
            fontSize: {
              xs: "0.875rem",
              sm: "1rem",
              md: "1.125rem",
              lg: "1.25rem",
              xl: "1.5rem",
            },
            textAlign: "justify",
            lineHeight: 1.6,
          }}
        >
          Welcome to the Quantlab function library. Here you will find all
          current types, classes, members, and functions that are built-in. This
          description is mainly help for coding and understanding the parameter
          types etc. For a more comprehensive description of Qlang and its
          usage, please see the documentation pages.
        </Typography>
      </div>
    </LandingPageWrapper>
  );
};
